import StoreContainer from "./StoreContainer";

class PostMessageStore {
  handleMessage = (event: { data: { type: string; data: any } }) => {
    if (event.data.type === "popout:end-chat") {
      StoreContainer.ChatStore.stopConnection();
      StoreContainer.EngagementStore.handleNoContent();
    }

    if (event.data.type === "popout:closed") {
      StoreContainer.FrameStore.popin();
      if (
        event.data.data.shouldExpand &&
        !StoreContainer.SettingStore.areCookiesDisabled()
      ) {
        StoreContainer.FrameStore.expand();
      }
    }
  };

  bind() {
    if (StoreContainer.FrameStore.isPopOut()) {
      this.bindPopout();
    } else {
      this.bindInline();
    }
  }

  unbind() {
    if (StoreContainer.FrameStore.isPopOut()) {
      this.unbindPopout();
    } else {
      this.unbindInline();
    }
  }

  sendEndChatMessage() {
    if (!StoreContainer.FrameStore.isPopOut()) {
      return;
    }
    const message = {
      type: "popout:end-chat"
    };

    if (window.parent && window.parent.opener) {
      window.parent.opener.postMessage(message, "*");
    }
  }

  private bindInline() {
    window.addEventListener("message", this.handleMessage);
  }

  private unbindInline() {
    window.removeEventListener("message", this.handleMessage);
  }

  private bindPopout() {
    window.onbeforeunload = () => {
      const inEngagement = StoreContainer.EngagementStore.hasEngagementId();

      const message = {
        type: "popout:closed",
        data: {
          shouldExpand: inEngagement
        }
      };
      window.parent.opener.postMessage(message, "*");
    };
  }

  private unbindPopout() {}
}

export default PostMessageStore;
